export const EVENT_TYPES = ["Academic", "Extra Curricular"];

export const EVENT_CODES = [
  { label: "SCORE", value: "SCORE" },
  { label: "HOTS", value: "Hots Olympiad" },
  {
    label: "English Olympiad",
    value: "English Olympiad",
  },
  { label: "Maths Olympiad", value: "Math Olympiad" },
  { label: "GIST", value: "GIST" },
  { label: "I-EMSAT", value: "I-EMSAT" },
  {
    label: "Career Counselling",
    value: "Career Counselling",
  },
  { label: "SCORE OFFLINE", value: "SCORE OFFLINE" },
  {
    label: "Genius Semi-Final",
    value: "Genius Semi-Final",
  },
  {
    label: "Genius Final",
    value: "Genius Final",
  },
  {
    label: "Youth Entrepreneurship Challenge",
    value: "Youth Entrepreneurship Challenge",
  },
  {
    label: "Atreya Scholarship Test",
    value: "AST",
  },
  {
    label: "SCORE Edge Scholarship Test",
    value: "SES",
  },
  {
    label: "Revision Test",
    value: "REVT",
  },
  {
    label: "Science Olympiad",
    value: "SO",
  },
  {
    label: "Score Edge",
    value: "SE",
  },
];

export const EVENT_CODES_NAMES = {
  SCORE: "SCORE",
  "Hots Olympiad": "Hots Olympiad",
  "English Olympiad": "English Olympiad",
  "Math Olympiad": "Math Olympiad",
  GIST: "Genius Intelligence Scale Test",
  "I-EMSAT": "I-EMSAT",
  "Career Counselling": "Career Counselling",
  "SCORE OFFLINE": "SCORE OFFLINE",
  "Genius Semi-Final": "Genius Semi-Final",
  "Genius Final": "Genius Final",
  "Youth Entrepreneurship Challenge": "Youth Entrepreneurship Challenge",
  SES: "SCORE Edge Scholarship Test",
  REVT: "Revision Test",
  AST: "Atreya Scholarship Test",
  SO: "Science Olympiad",
  SE: "Score Edge",
};

export const EXAM_NAMES = [
  "Aptitude Test",
  "Foundation Test",
  "NEET",
  "JEE Mains",
  "JEE Main",
  "CBSE",
  "CBSE Grade 9",
  "CBSE Grade 10",
  "Hots Olympiad",
  "Math Olympiad",
];
